import { css } from '@emotion/react';
import theme from 'storybookConfig/stories/theme';
import type { ThemeWash } from 'storybookConfig/stories/theme';

/**
 * A wash as the element's background. The washes blend `in oklab`; a browser without gradient
 * colour spaces (Safari before 16.2, Firefox before 127) drops that declaration whole, so the same
 * gradient blended in sRGB comes first as its fallback.
 */
const wash = (name: ThemeWash) => css`
  background: ${theme.wash[name].replace(/ in oklab/g, '')};
  background: ${theme.wash[name]};
`;

export default wash;
